/**
 * Created by seaasun on 2018/1/9.
 */
import _ from 'lodash'
export default {
  geoItems: state => {
    // for (let geo of state.OrderGeos) {
    //   if (state.GeoType === 10) {
    //     geo.text =
    //   }
    // }
    // let result = []
    // // justifiy use orderGoes, or orderAddress
    // let types = {
    //   geo: [5, 3, 2, 4, 10, 22, 23, 12],
    //   address: [13, 14, 16]
    // }
    // if (types.geo.indexOf(state.GeoType) !== -1) {
    //   result = state.OrderGeos
    // } else {
    //   for (let geo of state.OrderAddresses) {
    //     geo.GeoKeyDesc = geo.AddressLine
    //     geo.GeoKeyCode = geo.AddrSearchString
    //     result.push(geo)
    //   }
    //   // result = state.OrderAddresses
    // }
    return state.OrderGeos
  },
  demoItems: (state, getters) => {
    return state.OrderSelectedDemos || []
  },
  hasGeoItem: state => code => {
    for (let key of Object.keys(state.OrderGeos)) {
      if (code === state.OrderGeos[key].GeoKeyCode) {
        return true
      }
    }
    return false
  },
  geos: (state, getters, rootState) => {
    let geos = []
    let orderGeos = state.OrderGeos

    // preprocessing radius, polygon
    if (state.GeoType === 16 || state.GeoType === 12 || state.GeoType === 13 || state.GeoType === 7) {
      let orderAddress = _.filter(state.OrderAddresses, item => {
        return item.AddrUsageType === 2
      })
      orderGeos = _.map(orderAddress, item => {
        let result = {
          GeoKeyCode: item.AddrSearchString,
          GeoKeyDesc: item.AddressLine || item.AddressName,
          GeoType: state.GeoType
        }

        if (state.GeoType === 16 || state.GeoType === 7) {
          result.GeoKeyDesc += ` <br/> ${item.Radius} mile(s)`
        } else if (state.GeoType === 12) {
          result.GeoKeyDesc += `(Qty: ${item.Quantity})`
        }
        return result
      })
    }

    // group by geoType
    geos = _.groupBy(orderGeos, item => {
      return item.GeoType
    })

    let result = []
    for (let key of Object.keys(geos)) {
      geos[key] = _.map(geos[key], item => {
        item.OrderGeoDetails = item.OrderGeoDetails || []
        if (item.GeoType === rootState.config.geoType.city.code ||
            item.GeoType === rootState.config.geoType.congressionalDistrict.code ||
            rootState.order.ListType === 140 ||
            item.OrderGeoDetails === null ||
            item.OrderGeoDetails.length === 0 ||
            item.OrderGeoDetails[0].DetailDesc === null) {
          item.title = item.GeoKeyDesc
        } else {
          item.title = item.OrderGeoDetails[0].DetailDesc
        }
        return item
      })
      result.push({
        title: getters.getGeoType(parseInt(geos[key][0].GeoType)).title,
        values: geos[key]
      })
    }
    return result
  },
  demos: (state, getters, rootState) => {
    let demos = []
    if (state.ListType === 50) {
      demos = rootState.demo.option
      if (demos.length > 0) {
        demos[0].values = _.map(demos[0].values, item => {
          item.title = item.text
          item.key = demos[0].key
          item.is50 = true
          return item
        })
        demos[1].values = _.map(demos[1].values, item => {
          item.title = item.text
          item.key = demos[1].key
          item.is50 = true
          return item
        })
      }
    } else if (state.DemoType !== 99) {
      demos = state.OrderSelectedDemos || []
      demos = _.map(demos, item => {
        item.title = item.AttributeName
        let demoCategoryType = item.DemoCategoryType
        item.values = _.map(item.Values, item => {
          item.title = item.AttributeValueName
          item.DemoCategoryType = demoCategoryType
          return item
        })
        return item
      })
    } else {
      demos.push({
        title: rootState.demo.allHouseholdSetting.SettingDesc
      })
    }

    if (state.SuppressionType > 0) {
      let suppression = {
        title: 'Suppression',
        values: []
      }
      if (getters.suppressionType.order) {
        let items = []
        if (getters.suppressionType.order === 'date') {
          items.push(state.SuppressionStartDate + '~' + state.SuppressionEndDate)
        } else {
          for (let item of state.OrderSuppressions) {
            items.push(item.SuppressedOrderCode)
          }
        }
        if (items.length > 0) {
          suppression.values.push({
            title: 'Suppress Prior Order(s)',
            items,
            noDelete: true
          })
        }
      }
      if (getters.suppressionType.slc) {
        let items = []
        if (getters.suppressionType.slc === 'date') {
          items.push(state.SaveCountSuppressionStartDate + '~' + state.SaveCountSuppressionEndDate)
        } else {
          for (let item of state.SaveCountSuppressions) {
            items.push(item.SuppressedCountCode)
          }
        }
        if (items.length > 0) {
          suppression.values.push({
            title: 'Suppress Saved List Count(s)',
            items,
            noDelete: true
          })
        }
      }
      if (getters.suppressionType.file) {
        let items = []
        if (getters.suppressionType.file === 'date') {
          items.push(state.CustomSuppressionStartDate + '~' + state.CustomSuppressionEndDate)
        } else {
          for (let item of state.CustomSuppressions) {
            items.push(item.SuppressionValue)
          }
        }
        if (items.length > 0) {
          suppression.values.push({
            title: 'Suppress Uploaded File',
            items,
            noDelete: true
          })
        }
      }
      if (suppression.values.length > 0) {
        demos.push(suppression)
      }
    }

    if (getters['currentGeoType'].isDirectCount) {
      demos = [{
        title: 'Multi Saved List Count'
      }]
    }
    return demos
  },
  hasPhoneOption: state => {
    if (state.ListType === 50) {
      return true
    }
    return state.PhoneOption !== 0
  },
  hasEmailOption: state => {
    if (state.ListType !== 260) {
      return true
    }
    return state.EmailOption !== ''
  },
  demoColumnIndex: (state, getters) => (columnName, demoCategoryType) => {
    // @cloumnName str
    // retrun index of columnName in OrderSelectDemos
    //        -1 if there is no columnName in OrderSelectDemos
    for (let i = 0; i < getters.demoItems.length; i++) {
      getters.demoItems[i].ColumnName += ''
      if (columnName === getters.demoItems[i].ColumnName &&
          demoCategoryType === getters.demoItems[i].DemoCategoryType) {
        return i
      }
    }
    return -1
  },
  hasDemoByValue: (state, getters) => (columnName, demoCategoryType, AttributeValue) => {
    // @cloumnName str
    // retrun {}
    for (let item of getters.demoItems) {
      item.ColumnName += ''
      if (columnName === item.ColumnName && demoCategoryType === item.DemoCategoryType) {
        if (item.Values.filter(t=>t.AttributeValue===AttributeValue).length>0){
          return true
        }
      }
    }
    return false
  },
  demoColumnItem: (state, getters) => (columnName, demoCategoryType) => {
    // @cloumnName str
    // retrun {}
    for (let item of getters.demoItems) {
      item.ColumnName += ''

      if (columnName === item.ColumnName && demoCategoryType === item.DemoCategoryType) {
        return item
      }
    }
    return null
  },
  hasGeo: (state, getters) => {
    if (getters.geos) {
      return getters.geos.length > 0
    } else {
      return false
    }
  },
  hasDemo: (state, getters) => {
    if (state.DemoType === 99 || state.ListType === 50) {
      return true
    } else if (getters.demoItems.length > 0) {
      return true
    } else {
      return false
    }
  },
  hasDemoAndPhoneOption: (state, getters) => {
    if (state.ListType !== 50 && getters.hasDemo && getters.hasPhoneOption) {
      return true
    } else if (state.ListType === 50 && getters['demo/isTargetoption'] && getters['demo/isRouteoption']) {
      return true
    } else {
      return false
    }
  },
  hasDemoWithotAll: (state, getters) => {
    if (state.DemoType === 99) {
      return false
    } else {
      return getters.demoItems.length > 0
    }
  },
  isAllHoseholds: state => {
    return state.DemoType === 99
  },
  contact: state => {
    return state.OrderContactInformation
  },
  IsEmailCampaign: state => {
    return (state.ListType === 200 || state.ListType === 210)
  },
  orderaddress: state => {
    return state.OrderAddresses
  },
  orderGeos: state => {
    return state.OrderGeos
  },
  contactNameOption: state => {
    return state.ContactNameOption
  },
  targetOption: state => {
    return state.TargetOption
  },
  routeOption: state => {
    return state.RouteOption
  },
  demoBusinessTypeAddItem: state => {
    let result = []

    let demos = state.OrderSelectedDemos
    if (!demos) {
      return false
    }
    for (let demo of demos) {
      if (demo.DemoCategoryType === 4) {
        result.push(...demo.Values)
      }
    }
    return result
  },
  demoBusinessTypeAdd: (state, getters) => {
    let result = []
    let adds = getters.demoBusinessTypeAddItem
    if (adds.length > 0) {
      for (let item of adds) {
        result.push(item.AttributeValue)
      }
    }
    return result
  },
  isDemoBusinessTypeAdd: (state, getters) => code => {
    return getters.demoBusinessTypeAdd.indexOf(code) !== -1
  },
  demoBusinessTypeOmitItem: state => {
    let result = []
    let demos = state.OrderSelectedDemos
    if (!demos) {
      return false
    }
    for (let demo of demos) {
      if (demo.DemoCategoryType === 6) {
        result.push(...demo.Values)
      }
    }
    return result
  },
  demoBusinessTypeOmit: (state, getters) => {
    let result = []
    let adds = getters.demoBusinessTypeOmitItem
    if (adds.length > 0) {
      for (let item of adds) {
        result.push(item.AttributeValue)
      }
    }
    return result
  },
  isDemoBusinessTypeOmit: (state, getters) => code => {
    return getters.demoBusinessTypeOmit.indexOf(code) !== -1
  },
  totalDesiredQty: state => {
    return state.TotalDesiredQty
  },
  suppressionType: (state, getters, rootState) => {
    let type = state.SuppressionType || 0
    let dict = rootState.config.suppressionTypeMap
    if (dict.hasOwnProperty(type)) {
      return dict[type]
    } else {
      return dict[0]
    }
  },
  getGeoType: (state, getters, rootState) => geoType => {
    let geoTypes = rootState.config.geoType
    let result = _.find(geoTypes, item => {
      return item.code === geoType
    })
    if (result === undefined) {
      result = geoTypes.unKnow
    }
    return result
  },
  currentGeoType: (state, getters, rootState) => {
    let geoTypes = rootState.config.geoType
    let result = _.find(geoTypes, item => {
      return item.code === state.GeoType
    })
    if (result === undefined) {
      result = geoTypes.unKnow
    }
    return result
  },
  currentPhoneOption: (state, getters, rootState) => {
    if (rootState.demo.phoneOptions && rootState.demo.phoneOptions.hasOwnProperty(state.PhoneOption)) {
      return rootState.demo.phoneOptions[state.PhoneOption]
    } else {
      return {val: 0, desc: 'No Phone Option'}
    }
  },
  isCreditCard: (state) => {
    // 1: Using Credit Card
    // 2: Using invoice
    return state.PaymentMethod === 1
  }
}



// WEBPACK FOOTER //
// ./src/store/order/getters.js